export enum BankTransactionsEmptyStateVariant {
  General = 'general',
  ToReview = 'toReview',
  Reviewed = 'reviewed',
  NoFilterResults = 'noFilterResults',
}
